import SvgIcon, { SvgIconProps } from 'LuxKit/SvgIcon'

function LineLightbulbAltIcon(props: SvgIconProps) {
  return <SvgIcon {...props} fill="none" viewBox="0 0 24 24">
    <path fill="currentColor" d="M17.0899 2.82a7.9995 7.9995 0 0 0-6.68-1.66 8 8 0 0 0-6.27 6.32 8.0699 8.0699 0 0 0 1.72 6.65A4.54 4.54 0 0 1 7 17v3a3 3 0 0 0 3 3h4a3.0001 3.0001 0 0 0 3-3v-2.81A5.1702 5.1702 0 0 1 18.22 14a7.9996 7.9996 0 0 0-1.13-11.2v.02ZM14.9999 20a.9997.9997 0 0 1-1 1h-4a1.0002 1.0002 0 0 1-1-1v-1h6v1Zm1.67-7.24a7.1301 7.1301 0 0 0-1.67 4.24h-2v-3a.9997.9997 0 0 0-1-1 1.0003 1.0003 0 0 0-1 1v3h-2a6.5 6.5 0 0 0-1.6-4.16 6 6 0 0 1 3.39-9.72 6 6 0 0 1 7.21 5.88 5.8898 5.8898 0 0 1-1.33 3.76Z"/>
  </SvgIcon>
}

export default LineLightbulbAltIcon
